import script from "./AssessmentQuestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssessmentQuestion.vue?vue&type=script&setup=true&lang=ts"

import "./AssessmentQuestion.vue?vue&type=style&index=0&id=afa43a78&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afa43a78"]])

export default __exports__